import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { of } from 'rxjs';
import { concatMap, filter, map, withLatestFrom } from 'rxjs/operators';
import { FeatureManagementService } from 'src/app/features/feature-management/services';
import { RootStoreState } from 'src/app/store';
import { SpeechRecognitionService } from '../../services/speech-recognition.service';
import { AudioVideoConnectionMonitorSelectors } from 'src/app/features/audio-video-connection-monitor/store';
import { PackageUsersSelectors } from 'src/app/features/package-users';
import { Feature } from 'src/app/features/feature-management/models';
import { PackagesSelectors, ProductType } from 'src/app/features/packages';
import { SpeechRecognitionActions } from '../actions';

@Injectable()
export class SpeechRecognitionEffects {
    private _started = false;

  stopSpeechRecognition$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SpeechRecognitionActions.StopSpeechRecognition),
      filter(() =>
        this.featureManagementService.getIsFeatureEnabledWithCaching(Feature.NotaryCoach)
      ),
      map((_) => {
        if (this._started) {
          this.speechRecognitionService.stopRecognition();
          this._started = false;
        }
      })
    ),
    { dispatch: false }
  );

  startSpeechRecognition$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SpeechRecognitionActions.StartSpeechRecognition),
      filter(() =>
        this.featureManagementService.getIsFeatureEnabledWithCaching(Feature.NotaryCoach)
      ),
      concatMap((action) =>
        of(action).pipe(withLatestFrom(
            this.store.pipe(select(AudioVideoConnectionMonitorSelectors.getSelectedAudioDevice)),
            this.store.pipe(select(PackageUsersSelectors.getIsSigningAgent)),
            this.store.pipe(select(PackagesSelectors.getProductType)))
        )
      ),
      map(([_, audioDevice, isSigningAgent, productType]) => {
        if (isSigningAgent && productType === ProductType.RemoteSigning && !this._started) {
            this.speechRecognitionService.getSpeechKey().pipe(
              map((speechKey) => {
                this.speechRecognitionService.initRecognition( 
                  audioDevice.deviceId,
                  speechKey
                );
                this.speechRecognitionService.startContinuousRecognition();
              }
            )).subscribe();

            this._started = true;
        }
      }, 
    )),    
    { dispatch: false }
  );

  constructor(
    private readonly actions$: Actions,
    private readonly speechRecognitionService: SpeechRecognitionService,
    private readonly featureManagementService: FeatureManagementService,
    private readonly store: Store<RootStoreState.State>
  ) {}
}
